import React, { useState, useEffect } from "react";
import UserList from "../../components/common/UserList";
import { useAuth } from "../../context/AuthContext";
import AccessDenied from "../../components/common/AccessDenied";
import CardHeader from "../../components/common/CardHeader";
import PermissionCheckInProgress from "../../components/common/PermissionCheckInProgress";

function UserManagement() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [permissionCheckCompleted, setPermissionCheckCompleted] =
    useState(false);
  const { checkPermission } = useAuth();

  const permissionCheck = () => {
    setPermissionCheckCompleted(true);
  };

  const handleResize = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarVisible(true);
    } else {
      setIsSidebarVisible(false);
    }
  };

  useEffect(() => {
    permissionCheck();
    window.addEventListener("resize", handleResize);
    //handleResize(); // Wywołanie przy montowaniu komponentu

    return () => window.removeEventListener("resize", handleResize); // Oczyszczenie przy demontowaniu
  }, []);

  return (
    <>
      {permissionCheckCompleted ? (
        checkPermission("Zarządzanie użytkownikami") ? (
          <div className="content">
            <CardHeader text="Użytkownicy" onlyText="true" />
            <UserList />
          </div>
        ) : (
          <AccessDenied />
        )
      ) : (
        <PermissionCheckInProgress />
      )}
    </>
  );
}

export default UserManagement;
